import { autoinject, bindable } from 'aurelia-framework';
import { ServiceStructureService, ServiceNodeModel } from './service-structure-service';
import { remove } from 'lodash';

@autoinject
export class ServiceStructureManagement {
	@bindable structureId: string;
	@bindable structureName: string;
	@bindable searchTerm: string;
	@bindable services: ServiceNodeModel[] = null;

	@bindable selectedService: ServiceNodeModel;

	constructor(private serviceStructureService: ServiceStructureService) { }

	bind() {
		this.reloadServices();
	}

	serviceDeleted(event: CustomEvent) {
		const service = <ServiceNodeModel>event.detail.deletedService;
		if (service.parent) {
			remove(service.parent.children, c => c === service);
			service.parent.refreshChildren();
		} else {
			remove(this.services, c => c === service);
		}

		if (service === this.selectedService) {
			this.selectedService = null;
		}
	}

	serviceAdded(event: CustomEvent) {
		const service = <ServiceNodeModel>event.detail.addedService;
		const parentService = <ServiceNodeModel>event.detail.parentService;

		if (parentService) {
			parentService.children.push(service);
			service.parent = parentService;
			service.parent.refreshChildren();
		} else {
			this.services.push(service);
		}

		this.selectedService = service;
	}

	async reloadServices(): Promise<any> {
		this.services = null;
		this.services = await this.serviceStructureService.getServiceStructure(this.structureId);
	}
}
